import React, { useContext, useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import ProductionLineSelector from "../ProductionLineSelector/ProductionLineSelector";
import "./WintNavbar.css";
import "react-dropdown/style.css";
import { Button, Dropdown, Form } from "react-bootstrap";
import { BiLogOutCircle } from "react-icons/all";
import { store } from "../../Store/store";
import { unitMeasurementSystem } from "../../enums";

export default function WintNavbar(props) {
  const logoPath = process.env.REACT_APP_LOGO_PATH;
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const globalState = useContext(store);
  const { dispatch } = useContext(store);
  const lineType =
    globalState.state.selectedProductionLine?.lineType ||
    JSON.parse(globalState.state.selectedProductionLine)?.lineType;
  const [unit, setUnit] = useState(() => {
    return (
      localStorage.getItem("wintNavbarUnit") ||
      (process.env.REACT_APP_COMPANY_NAME === "Coca-Cola"
        ? unitMeasurementSystem.IMPERIAL
        : unitMeasurementSystem.METRIC)
    );
  });

  const getClassName = (route) => {
    const currentPath = window.location.pathname;
    if (currentPath === route) {
      return "navbar-selected-tab";
    }
  };

  useEffect(() => {
    localStorage.setItem("wintNavbarUnit", unit);
    dispatch({
      type: "SET_UNIT",
      payload: unit,
    });
  }, [unit]);

  return (
    <Navbar bg="light" variant="light" expand="lg">
      <Navbar.Brand className="pt-0">
        {logoPath && <img src={logoPath} alt={companyName || "Company logo"} />}
      </Navbar.Brand>
      <Nav className="mr-auto">
        <Nav.Link href="/dashboard" className={getClassName("/dashboard")}>
          Runs
        </Nav.Link>
        <Nav.Link
          href="/cipAnalytics"
          className={getClassName("/cipAnalytics")}
        >
          CIP Analytics
        </Nav.Link>
        {/* {lineType === 'beverages' && (
                    <Nav.Link
                        href="/weeklyTrend"
                        className={getClassName("/weeklyTrend")}
                    >
                        Weekly Trend
                    </Nav.Link>
                )} */}
      </Nav>

      {!props.isSignedOutPage && (
        <div className="d-flex align-items-center">
          <ProductionLineSelector isCookieSaved={props.isCookieSaved} />
          <Dropdown className="ml-3">
            <Dropdown.Toggle variant="primary" id="units-dropdown">
              {unit}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => setUnit(unitMeasurementSystem.METRIC)}
              >
                {unitMeasurementSystem.METRIC}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setUnit(unitMeasurementSystem.IMPERIAL)}
              >
                {unitMeasurementSystem.IMPERIAL}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Nav.Link href="/signed-out?logout=true">
            <Form inline>
              <Button>
                <BiLogOutCircle />
              </Button>
            </Form>
          </Nav.Link>
        </div>
      )}

      {props.isSignedOutPage && (
        <Nav.Link href="/">
          <Form inline>
            <Button variant="success" onClick={() => window.location.reload()}>
              Log In
            </Button>
          </Form>
        </Nav.Link>
      )}
    </Navbar>
  );
}
